import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  data: {},
};

const vyjadrenie = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.VYJADRENIE_SAVE_DATA:
      return { ...state, data: { ...state.data, ...action.data } };

    case actionTypes.CHANGE_VYJADRENIE:
      return { ...state, data: { ...action.data } };

    case actionTypes.CREATE_VYJADRENIE_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.CREATE_VYJADRENIE_SUCCESS: {
      return { ...state, isLoading: false };
    }
    case actionTypes.CREATE_VYJADRENIE_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default vyjadrenie;
